module.exports = __webpack_public_path__ + "static/media/CarouselLeftArrowDisable.3f702228.svg";